/* @ngInject */
function AnnotationPinController ($scope, UserService, AdminService) {
  $scope.author = {}

  const api = {
    _getAuthor
  }
  this.getApi = () => api

  activate()

  function activate () {
    if ($scope.authorId) {
      api._getAuthor($scope.authorId)
    }
  }

  $scope.getAvatarUrl = (user) => {
    return UserService.getUserProfileImage(user.userId)
  }

  function _getAuthor (authorId) {
    AdminService.getUserById(authorId).then(user => {
      $scope.author = user
    })
  }
}

export { AnnotationPinController }
